import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ClockOutline } from '@lyearn/icons';
import { BaseButton, Stack, Typography } from '@lyearn/ui';

import { QuizHistoryButtonProps } from './types';

const QuizHistoryButton: React.FC<QuizHistoryButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <BaseButton className="m-0 rounded-full p-0 hover:bg-bg-hover" onClick={onClick}>
      <Stack alignItems="center" className="px-8 py-4" gapX={6}>
        <ClockOutline className="h-14 w-14" fillColorToken="icon-secondary" />
        <Typography color="text-text-secondary" variant="body-short-02">
          {t('QuizPlayer:History')}
        </Typography>
      </Stack>
    </BaseButton>
  );
};

export default QuizHistoryButton;
